var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13138_47830",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 -0.00195312H-0.0078125V23.998H23.9922V-0.00195312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13138_47830)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13138_47830",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 25,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.015625 -0.00390434H23.9844V23.9961H-0.015625V-0.00390434Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13138_47830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.6211V3.7461C8 2.1928 9.2592 0.933596 10.8125 0.933596H20.2344C21.7877 0.933596 23.0469 2.1928 23.0469 3.7461V20.2461C23.0469 21.7994 21.7877 23.0586 20.2344 23.0586H10.8125C9.2592 23.0586 8 21.7994 8 20.2461V18.3711",
    stroke: "#6F767E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 11.9961H0.921875",
    stroke: "#6F767E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 15.0898L13.3505 12.9905C13.904 12.4413 13.904 11.5509 13.3505 11.0017L11.2344 8.90234",
    stroke: "#6F767E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskgroup);
export default __webpack_public_path__ + "static/media/Mask group.87948a77e54af472906362e6338abf77.svg";
export { ForwardRef as ReactComponent };